import Vue from 'vue';
import Vuex from 'vuex';

import accounts from './modules/accounts';
import agentBots from './modules/agentBots';
import agents from './modules/agents';
import aiFieldFillSettings from './modules/aiFieldFillSettings';
import articles from './modules/helpCenterArticles';
import attributes from './modules/attributes';
import customAttributePermissions from './modules/customAttributePermissions';
import auth from './modules/auth';
import auditlogs from './modules/auditlogs';
import automations from './modules/automations';
import bulkActions from './modules/bulkActions';
import campaigns from './modules/campaigns';
import claudiaEvents from './modules/claudiaEvents';
import claudiaTakeover from './modules/claudiaTakeover';
import claudiaTakeoverBatch from './modules/claudiaTakeoverBatch';
import messageGroups from './modules/messageGroups';
import cannedResponse from './modules/cannedResponse';
import categories from './modules/helpCenterCategories';
import contactConversations from './modules/contactConversations';
import contactLabels from './modules/contactLabels';
import contactNotes from './modules/contactNotes';
import contacts from './modules/contacts';
import conversationLabels from './modules/conversationLabels';
import conversationMetadata from './modules/conversationMetadata';
import conversationFilterOptions from './modules/conversationFilterOptions';
import conversationPage from './modules/conversationPage';
import conversations from './modules/conversations';
import conversationKanban from './modules/conversationKanban';
import conversationSearch from './modules/conversationSearch';
import conversationStats from './modules/conversationStats';
import conversationTypingStatus from './modules/conversationTypingStatus';
import conversationWatchers from './modules/conversationWatchers';
import csat from './modules/csat';
import customViews from './modules/customViews';
import customRole from './modules/customRole';
import dashboardApps from './modules/dashboardApps';
import globalConfig from 'shared/store/globalConfig';
import hub from './modules/hub';
import inboxAssignableAgents from './modules/inboxAssignableAgents';
import inboxes from './modules/inboxes';
import inboxMembers from './modules/inboxMembers';
import integrations from './modules/integrations';
import labels from './modules/labels';
import layoutOverrides from './modules/layoutOverrides';
import macros from './modules/macros';
import notifications from './modules/notifications';
import nativeAttributes from './modules/nativeAttributes';
import portals from './modules/helpCenterPortals';
import reports from './modules/reports';
import sla from './modules/sla';
import teamMembers from './modules/teamMembers';
import teams from './modules/teams';
import teamSettingOverrides from './modules/teamSettingOverrides';
import userNotificationSettings from './modules/userNotificationSettings';
import webhooks from './modules/webhooks';
import draftMessages from './modules/draftMessages';
import SLAReports from './modules/SLAReports';
import availability from './modules/availability';
import emailCampaignDomains from './modules/emailCampaignDomains';
import emailCampaignSenders from './modules/emailCampaignSenders';
import emailSuppressions from './modules/emailSuppressions';

const plugins = [];

Vue.use(Vuex);
export default new Vuex.Store({
  modules: {
    accounts,
    agentBots,
    agents,
    aiFieldFillSettings,
    articles,
    attributes,
    customAttributePermissions,
    auth,
    automations,
    auditlogs,
    bulkActions,
    campaigns,
    cannedResponse,
    categories,
    claudiaEvents,
    claudiaTakeover,
    claudiaTakeoverBatch,
    messageGroups,
    contactConversations,
    contactLabels,
    contactNotes,
    contacts,
    conversationLabels,
    conversationMetadata,
    conversationFilterOptions,
    conversationPage,
    conversations,
    conversationKanban,
    conversationSearch,
    conversationStats,
    conversationTypingStatus,
    conversationWatchers,
    csat,
    customViews,
    customRole,
    dashboardApps,
    globalConfig,
    hub,
    inboxAssignableAgents,
    inboxes,
    inboxMembers,
    integrations,
    labels,
    layoutOverrides,
    macros,
    nativeAttributes,
    notifications,
    portals,
    reports,
    teamMembers,
    teams,
    teamSettingOverrides,
    userNotificationSettings,
    webhooks,
    draftMessages,
    sla,
    slaReports: SLAReports,
    availability,
    emailCampaignDomains,
    emailCampaignSenders,
    emailSuppressions,
  },
  plugins,
});
